import SearchIcon from 'assets/svg/search/search.svg'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import highlighter from 'lib/highlighter'
import { ISuggestionItem } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import styled from 'styled-components'

const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;
`

function Items({
  suggestionItem,
  keywords,
  isHighlited,
}: ISuggestionItem): JSX.Element {
  const handleItemClick = () => {
    window.location.assign(
      `${WEB_DESKTOP_RALALI_URL}/v/${suggestionItem.seller.alias}/product/${suggestionItem.alias}`,
    )
  }

  return (
    <StyledListItemResult
      onClick={handleItemClick}
      isHighlited={isHighlited}
      data-testId="product-item"
    >
      <SearchIcon width="13" height="13" />
      <HighlitedText
        dangerouslySetInnerHTML={{
          __html: highlighter(suggestionItem.name, keywords),
        }}
        data-testid="product-item-text"
      />
    </StyledListItemResult>
  )
}

export default Items
